module.exports = __webpack_public_path__ + "static/media/ball_1_9.387c018d.mp3";